import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 overflow-auto" }
const _hoisted_2 = { class: "flex rlex-col flex-wrap items-center justify-center px-8 py-3" }
const _hoisted_3 = { class: " text-gray-lp-300 text-base font-bold" }
const _hoisted_4 = { class: " text-gray-lp-800 text-sm" }
const _hoisted_5 = { class: "flex rlex-col flex-nowrap items-center justify-center mt-3" }
const _hoisted_6 = { class: "flex rlex-row items-center justify-center gap-2" }
const _hoisted_7 = { class: "flex rlex-row px-8 rounded-lg items-end justify-end gap-2 bg-gray-lp-1000 mt-2 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "modal_ticket_preview",
    buttonId: "btn_close_modal_ticket_preview",
    modelValue: _ctx.openDialog,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDialog = $event)),
    title: _ctx.$t('pusatResolusi.review.titleIssueNo', { ticketNo: _ctx.ticketNo }),
    titleSize: "16",
    closeIcon: "x-gray-24",
    onReset: _ctx.cancelPopup,
    persistent: "",
    textColor: "text-gray-lp-300"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("section", null, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("pusatResolusi.review.giveRating")), 1),
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("pusatResolusi.review.ratingHint")), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectRating('good'))),
                class: [
                ' w-10 h-10 flex items-center rounded-full cursor-pointer',
                _ctx.selectedType === 'good' ? 'bg-blue-lp-700' : 'bg-gray-lp-200'
              ]
              }, [
                _createVNode("img", {
                  src: 
                  _ctx.selectedType === 'good'
                    ? require('@/app/ui/assets/svg/ics_f_thumb-good-white.svg')
                    : require('@/app/ui/assets/svg/ics_f_thumb-good.svg')
                ,
                  class: " w-6 h-6 cursor-pointer block m-auto",
                  alt: "thumb-good"
                }, null, 8, ["src"])
              ], 2),
              _createVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectRating('neutral'))),
                class: [
                ' w-10 h-10 flex items-center rounded-full cursor-pointer',
                _ctx.selectedType === 'neutral'
                  ? 'bg-yellow-lp-1500'
                  : 'bg-gray-lp-200'
              ]
              }, [
                _createVNode("img", {
                  src: 
                  _ctx.selectedType === 'neutral'
                    ? require('@/app/ui/assets/svg/ics_f_thumb-neutral-white.svg')
                    : require('@/app/ui/assets/svg/ics_f_thumb-neutral.svg')
                ,
                  class: " w-6 h-6 cursor-pointer block m-auto",
                  alt: "thumb-neutral"
                }, null, 8, ["src"])
              ], 2),
              _createVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectRating('bad'))),
                class: [
                ' w-10 h-10 flex items-center rounded-full cursor-pointer',
                _ctx.selectedType === 'bad' ? 'bg-red-lp-100' : 'bg-gray-lp-200'
              ]
              }, [
                _createVNode("img", {
                  src: 
                  _ctx.selectedType === 'bad'
                    ? require('@/app/ui/assets/svg/ics_f_thumb-bad-white.svg')
                    : require('@/app/ui/assets/svg/ics_f_thumb-bad.svg')
                ,
                  class: " w-6 h-6 cursor-pointer block m-auto",
                  alt: "thumb-bad"
                }, null, 8, ["src"])
              ], 2)
            ])
          ])
        ]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pusatResolusi.review.reviewLabel'),
          suffix: _ctx.$t('pusatResolusi.review.optional'),
          optional: true,
          class: "w-full px-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              type: "textarea",
              maxLength: "255",
              textAreaRows: "3",
              placeholder: _ctx.$t('pusatResolusi.review.reviewPlaceholder'),
              showMaxLength: true,
              modelValue: _ctx.feedback,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.feedback = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        }, 8, ["label", "suffix"]),
        _createVNode("section", _hoisted_7, [
          _createVNode(_component_LpButton, {
            id: "button_cancel_modal_review_ticket",
            title: _ctx.$t('pusatResolusi.review.cancel'),
            outline: "",
            "text-color": "red-lp-100",
            onClick: _ctx.cancelPopup,
            medium: ""
          }, null, 8, ["title", "onClick"]),
          _createVNode(_component_LpButton, {
            id: "button_submit_modal_review_ticket",
            title: _ctx.$t('pusatResolusi.review.submit'),
            "text-color": "white",
            disabled: _ctx.disabledSubmitButton,
            onClick: _ctx.onSubmit,
            medium: ""
          }, null, 8, ["title", "disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onReset"]))
}